import { motion } from "framer-motion";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  {
    q: "Qu'est-ce que je reçois exactement ?",
    a: `- Les cinq actes de MULTIPOLAR
- les documents sources utilisés dans le programme
Tout est inclus, sans surcoût.
Les actes sortent progressivement selon le calendrier : ceux déjà disponibles sont accessibles immédiatement, les suivants s'ajoutent à ton espace membre à chaque sortie.`,
  },
  {
    q: "Quand est-ce que je reçois les actes ?",
    a: `Chaque acte est ajouté à ton espace membre le jour de sa sortie (voir le calendrier).
Tu es prévenu par email.`,
  },
  {
    q: "Combien de temps j'ai accès ?",
    a: `À vie, tant que MULTIPOLAR existe.`,
  },
  {
    q: "Est-ce que MULTIPOLAR est un conseil en investissement ?",
    a: `Non.
Je ne suis pas conseiller en investissements financiers et je n'exerce aucune activité réglementée.
MULTIPOLAR est un contenu d'analyse et d'opinion à vocation informative et pédagogique, qui ne tient pas compte de ta situation personnelle.
Investir comporte un risque de perte en capital.
Les performances passées ne préjugent pas des performances futures.
Toute décision d'investissement relève de ta seule responsabilité.`,
  },
  {
    q: "Comment fonctionne l'accès ?",
    a: `L'accès est immédiat après l'achat. Tu reçois un email contenant tes identifiants pour te connecter à l'espace membre. Une fois connecté, tu retrouves le programme avec les différents actes.`,
  },
  {
    q: "C'est quoi, le mois d'OPENACCESS offert ?",
    a: `OPENACCESS est mon groupe privé où je partage mon portefeuille réel, mes achats, mes ventes et mes analyses. En achetant MULTIPOLAR, tu y as accès pendant un mois, sans rien à payer ni carte à renseigner. Les instructions t'arrivent par email après l'achat.`,
  },
];

export default function Faq() {
  return (
    <section id="faq" data-testid="faq-section" className="py-24 md:py-32">
      <div className="max-w-4xl mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8 }}
          className="mb-12"
        >
          <span className="micro-label">Questions</span>
          <h2 className="font-display text-4xl sm:text-5xl leading-[1.05] mt-6">
            Ce qu'on nous demande <span className="italic text-[#FF6B00]">souvent</span>.
          </h2>
        </motion.div>

        <Accordion type="single" collapsible className="w-full">
          {faqs.map((f, i) => (
            <AccordionItem key={i} value={`item-${i}`} className="border-white/10" data-testid={`faq-item-${i}`}>
              <AccordionTrigger
                data-testid={`faq-trigger-${i}`}
                className="text-left font-mono text-xs md:text-sm tracking-[0.15em] uppercase text-[#F5F5F0] hover:text-[#FF6B00] hover:no-underline py-6"
              >
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-[#D8D4CC] font-light pb-8 max-w-[70ch]">
                {f.a.split("\n").map((line, i) => (
                  <p key={i} className="mb-[1em] last:mb-0">{line}</p>
                ))}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
